import { useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectToken } from "../../features/auth/authSlice";
import {
  createDaoTrang,
  getAllDaoTrangs,
  newDefaultDaoTrang,
  removeDaoTrang,
  saveDaoTrang,
} from "../../services/daoTrang/daoTrangApi";
import {
  Button,
  ButtonGroup,
  Input,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import classes from "./DaoTrangList.module.css";
import moment from "moment";
import {
  addDaoTrang,
  deleteDaoTrang,
  editDaoTrang,
  selectDaoTrangs,
  setActiveDaoTrang,
  setDaoTrangs,
} from "../../features/daoTrang/daoTrangSlice";
import { Content } from "../Content/Content";
import { Popup } from "../dialog/Popup";
import { ConfirmButton } from "../dialog/ConfirmButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CommonTable } from "../Layout/CommonTable";
import { BigSpin } from "../DaoTrang/BigSpin";
import { MyContainer } from "../Layout/MyContainer";

const DaoTrangEdit = ({ refUser }) => {
  console.log(refUser);
  const obj = refUser.current;
  const [edited, saveEdited] = useState({ ...obj });
  const handleChange = (f, v) => {
    var newObj = { ...edited, [f]: v };
    saveEdited(newObj);
    refUser.current = newObj;
  };
  return (
    <Stack spacing={2} direction={"column"}>
      {Object.keys(edited).map((f, i) => (
        <TextField
          key={i}
          label={f}
          value={Array.isArray(edited[f]) ? edited[f].join(",") : edited[f]}
          onChange={(e) => handleChange(f, e.target.value)}
          size="small"
        ></TextField>
      ))}
    </Stack>
  );
};

const DaoTrangList = ({ navigate, params = {} }) => {
  function f(iRow, iCol, row) {
    var k = cols[iCol].k;
    const v = row[k];
    return v;
  }

  const cols = [
    {
      l: "No",
      w: 70,
      f: function (iRow, iCol, daoTrang) {
        return (
          <Button onClick={() => handleSelect(daoTrang)} variant="text">
            {iRow + 1}
          </Button>
        );
      },
    },
    { f, k: "maDaoTrang", l: "MS", w: 150 }, // maDaoTrang
    { f, k: "name", l: "Tên", w: 150 }, // name
    { f, k: "description", l: "Ghi chú", w: 300 }, // description
    { f, k: "createdDate", t: "date", l: "CreatedDate", w: 150 }, // name
    {
      l: "Action",
      w: 150,
      f: function (iRow, iCol, daoTrang) {
        return (
          <ButtonGroup>
            <Button variant="text" onClick={() => onEdit(daoTrang.id)}>
              edit
            </Button>
            <ConfirmButton
              onOk={() => onDelete(daoTrang.id)}
              title={"Delete DT"}
              message={`Are you sure to delete dt [${daoTrang.name}]?`}
            >
              <Button variant="text">delete</Button>
            </ConfirmButton>
          </ButtonGroup>
        );
      },
    }, // edit delete
  ];

  console.log("DaoTrangList");
  const token = useAppSelector(selectToken);
  const daoTrangs = useAppSelector(selectDaoTrangs);
  const dispatch = useAppDispatch();

  const [loadingState, setLoadingState] = useState("idle");
  const [open, setOpen] = useState(false);
  const refUser = useRef(null);
  console.log(refUser.current);

  useEffect(() => {
    async function loader() {
      try {
        setLoadingState("loading");
        const { result, error } = await getAllDaoTrangs(token);
        if (!error) {
          dispatch(setDaoTrangs({ daoTrangs: result }));
        }
      } finally {
        setLoadingState("idle");
      }
    }

    if (!daoTrangs) {
      loader();
    } else {
      console.log("skip load");
    }
  }, [daoTrangs, dispatch, token]);

  const onAdd = () => {
    var newObj = newDefaultDaoTrang();
    newObj.owner = token;
    refUser.current = newObj;
    setOpen(true);
  };
  const onEdit = (id) => {
    const org = daoTrangs.find((dt) => dt.id === id);
    refUser.current = { ...newDefaultDaoTrang(), ...org };
    setOpen(true);
  };
  const onDelete = async (id) => {
    const { error } = await removeDaoTrang(id);
    if (!error) {
      dispatch(deleteDaoTrang({ id }));
    }
  };
  function renderRow(dt, onChange, editLst = [], hdrs = cols) {
    const id = dt.id;
    return hdrs
      .filter(({ f: field }) => !!field)
      .map((h) => {
        const label = h.l;
        const field = h.f;
        const dataType = h.t;
        const val = dt[field];

        if (!h.editAble) {
          return <div className={`${classes.cell_text}`}>{val}</div>;
        }

        if (h.render) {
          return h.render(val, function (v) {
            console.log(field, ":", v);
            onChange({ id, change: { [field]: v } });
          });
        } else if (dataType === "date") {
          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                variant="standard"
                disableUnderline={true}
                size="small"
                // label={label}
                format="YYYY"
                value={val ? dayjs(val) : null}
                onChange={(dayVal) =>
                  onChange({
                    id,
                    change: { [field]: dayVal.format("YYYY-MM-DD") },
                  })
                }
              />
            </LocalizationProvider>
          );
        } else {
          // console.log(field)
          return (
            <Input
              variant="standard"
              disableUnderline={true}
              // label={label}
              type="text"
              value={val || ""}
              onChange={(e) =>
                onChange({
                  id,
                  change: { [field]: e.target.value },
                })
              }
            ></Input>
          );
        }
      });
  }

  const onChange = ({ id, change }) => {};


  function handleSelect(daoTrang) {
    navigate("/DaoTrang", { id: daoTrang.id });
  }

  const transformed = daoTrangs || [];

  return (
    <Content
      title={
        <Stack spacing={2} direction={"row"}>
          <Typography variant="h6">All DaoTrangs</Typography>{" "}
          <Popup
            init={open}
            title={"New Dao Trang"}
            content={<DaoTrangEdit refUser={refUser} />}
            onOk={async () => {
              console.log(refUser.current);
              var newObj = refUser.current;
              if (!newObj.id) {
                var { result, error } = await createDaoTrang(newObj);
                if (error) {
                  console.log(error);
                } else {
                  dispatch(addDaoTrang({ daoTrang: result }));
                  refUser.current = null;
                }
              } else {
                var { result, error } = await saveDaoTrang(newObj);
                if (error) {
                  console.log(error);
                } else {
                  dispatch(editDaoTrang({ id: result.id, changes: result }));
                  refUser.current = null;
                }
              }
            }}
            onClose={() => setOpen(false)}
          ></Popup>
          <Button variant="contained" onClick={() => onAdd()}>
            Add
          </Button>
        </Stack>
      }
      footer={
        <Stack spacing={2} direction={"row"}>
          <Button
            variant="contained"
            onClick={() => {
              console.log("save daotrang");
            }}
          >
            save
          </Button>
        </Stack>
      }
    >
      {loadingState === "loading" ? (
        <MyContainer>
          <BigSpin></BigSpin>
        </MyContainer>
      ) : (
        <CommonTable data={transformed} cols={cols}></CommonTable>
      )}
    </Content>
  );
};

export default DaoTrangList;
